import { useMutation } from '@tanstack/react-query';

import { User } from 'src/features/auth/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { ChangeCurrentUserPasswordFormSchemaValues } from 'src/features/profile/utils/formSchema';

const RESOURCE = '/users/user/change-password/';

type MutationFnType = typeof mutationFn;

const mutationFn = (data: ChangeCurrentUserPasswordFormSchemaValues): Promise<User> => {
    return axios.post(RESOURCE, data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useChangeCurrentUserPassword };
